// @ts-ignore
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import { MoneyFragmentDoc } from '../../../fragments/money.fragment.generated';
export const GemsPriceRangeInLocalCurrencyFragmentDoc = gql`
    fragment gemsPriceRangeInLocalCurrency on GemsApi_PriceRange {
  min
  max
  minInCurrency(currency: $currency, region: $region) {
    ...money
  }
  maxInCurrency(currency: $currency, region: $region) {
    ...money
  }
}
    ${MoneyFragmentDoc}`;